import { useCallback } from 'react';
import { useTranslationContext, fallbackLocalizedText } from './42d814874415aa7ed68787d683b3358e9f7a082e7134e08a169c9fab9c21cc57.cfe-internal.js';
import insertPlaceholders from './4563f607042623696cae2f0a13e325449dcd9513e51af0e3a22570c169786d88.cfe-internal.js';
import containsComponentOrElement from './cbb7b69da2d2d9683cdea6e31a9e1fd3aeb111eb08b393d6f48922e56ef0f8a9.cfe-internal.js';

/* eslint-disable babel/no-unused-expressions */

var NO_LOCALIZED_TEXT = function NO_LOCALIZED_TEXT(key) {
  return "There is no localized text for KEY: ".concat(key, ". Defaulting to fallback text");
};

var NO_LOCALIZED_OR_FALLBACK_TEXT = function NO_LOCALIZED_OR_FALLBACK_TEXT(key) {
  return "There is no localized or fallback text for KEY: ".concat(key, ". \n    Please refer to https://designsystem.qualtrics.com/localization for more information about localizing Qualtrics ui-react components");
};

var USETRANSLATION_PLACEHOLDER_CONTAINS_ELEMENT = 'The useTranslation function cannot include React elements as placeholders.';
/**
 * Returns a translate function.
 * @returns A translate function.
 */

var useTranslation = function useTranslation() {
  var _useTranslationContex = useTranslationContext(),
      localizedText = _useTranslationContex.localizedText;
  /**
   * Returns a translated string given a key and placeholders.
   * @param key - The key of the translated string.
   * @param placeholders - A map of parameters to replace in the translated string. The string is searched for each key in the map wrapped by {{}} and then replaced with the corresponding value. *Placeholders can't be components. To use a component placeholder, use the `Translate` component.*
   * @returns The translated string if found; otherwise `##${translation-key}##`.
   */


  var translate = useCallback(function (key, placeholders) {
    var translatedText = localizedText === null || localizedText === void 0 ? void 0 : localizedText[key];
    var fallbackText = fallbackLocalizedText[key];

    if (!translatedText) {
      fallbackText ? console.warn(NO_LOCALIZED_TEXT(key)) : console.warn(NO_LOCALIZED_OR_FALLBACK_TEXT(key));
    }

    var text = translatedText || fallbackText;

    if (text && placeholders) {
      if (containsComponentOrElement(placeholders)) {
        console.warn(USETRANSLATION_PLACEHOLDER_CONTAINS_ELEMENT);
        return '';
      }

      var compiledMessage = insertPlaceholders(text, placeholders);
      return compiledMessage.join('');
    }

    return text || "##".concat(key, "##");
  }, [localizedText]);
  return {
    translate: translate
  };
};

var useTranslation$1 = useTranslation;

export { useTranslation$1 as default };
